/** @jsx jsx */
import { Incident } from "../../types"
import { IncidentRow } from "../IncidentRow"
import { jsx } from "theme-ui"
import * as styles from "./styles"
import React from "react"

interface IncidentsTableProps {
  incidents: Incident[]
  searchWords: string[]
}

export const IncidentsTable: React.FC<IncidentsTableProps> = ({
  incidents,
  searchWords,
}) => {
  return (
    <table sx={styles.root}>
      <tbody>
        {incidents.map(incident => (
          <IncidentRow
            incident={incident}
            key={incident.id}
            searchWords={searchWords}
          />
        ))}
      </tbody>
    </table>
  )
}
